import {useCallback, useState} from 'react'
import useNotification from '@/hooks/notification'

const useCopyToClipboard = () => {
  const [, setIsCopied] = useState(false)
  const {showNotification} = useNotification()

  const copyToClipboard = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text)
        setIsCopied(true)
        showNotification('Text copied to clipboard!', 'success')
        setTimeout(() => {
          setIsCopied(false)
        }, 2000)
      } catch (e) {
        console.error('Failed to copy: ', e)
      }
    },
    [showNotification]
  )

  return {copyToClipboard}
}

export default useCopyToClipboard
